import { useMemo, useState } from 'react';
import { termsOfServiceStepIndex } from '../../ClientOnboarding.utils';
export const useTermsOfServiceStatement = (param)=>{
    let { relationship, currentStep, shouldSignStatement, isPreview } = param;
    var _termsOfServiceStepIndex_currentStep;
    const termsOfServices = useMemo(()=>{
        var _ref;
        var _relationship_legalTermsDocuments;
        return (_ref = (_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : _relationship_legalTermsDocuments.slice(0, 4)) !== null && _ref !== void 0 ? _ref : [];
    }, [
        relationship.legalTermsDocuments
    ]);
    const [termsOfServiceStatements, setTermsOfServiceStatements] = useState(()=>termsOfServices.map((termsOfService)=>shouldSignStatement || isPreview ? !(termsOfService.termsOfService.type === 'explicitApproval' && termsOfService.termsOfService.explicitApproval.statement) : true));
    const currentTermsIndex = (_termsOfServiceStepIndex_currentStep = termsOfServiceStepIndex[currentStep]) !== null && _termsOfServiceStepIndex_currentStep !== void 0 ? _termsOfServiceStepIndex_currentStep : -1;
    const isTermsOfServiceStep = currentTermsIndex >= 0;
    const isStatementAccepted = isTermsOfServiceStep ? termsOfServiceStatements[currentTermsIndex] : true;
    const currentStatement = useMemo(()=>{
        if (!isTermsOfServiceStep || !shouldSignStatement && !isPreview) return null;
        const termsOfService = termsOfServices[currentTermsIndex];
        if (!termsOfService) return null;
        return termsOfService.termsOfService.type === 'explicitApproval' ? termsOfService.termsOfService.explicitApproval.statement : null;
    }, [
        isTermsOfServiceStep,
        currentTermsIndex,
        termsOfServices,
        shouldSignStatement,
        isPreview
    ]);
    const handleStatementChange = (isAccepted)=>{
        if (currentTermsIndex >= 0) {
            setTermsOfServiceStatements((prev)=>{
                const next = [
                    ...prev
                ];
                next[currentTermsIndex] = isAccepted;
                return next;
            });
        }
    };
    const isNextDisabled = isTermsOfServiceStep && !isStatementAccepted;
    const hasUnacceptedStatements = !isPreview && termsOfServiceStatements.includes(false);
    return {
        currentStatement,
        isStatementAccepted,
        isTermsOfServiceStep,
        isNextDisabled,
        hasUnacceptedStatements,
        handleStatementChange
    };
};
